import { Carousel, CarouselSlide } from 'components/Content/Atoms/Carousel';
import { ContentType } from 'types/publishedAssets';
import { useGetContentTranslations } from 'utils/useGetContentTranslations';
import { ContentContainer, SMALL, MEDIUM, LARGE, FULL } from 'components/Content/Atoms/ContentContainer';
import { BlockHeading } from 'components/Content/Atoms/BlockHeading';
import styles from './ImageGallery.module.scss';
import { ImageGalleryAtom } from './ImageGalleryAtom';

interface ImageGallerySlideshowProps {
  content: ContentType;
}

export function ImageGallerySlideshow({ content }: ImageGallerySlideshowProps) {
  const { getMediaItemFromComponent, getImageCropFromComponent, translate } = useGetContentTranslations();
  let size = LARGE;
  switch (content.metadata.size) {
    case 'full':
      size = FULL;
      break;
    case 'medium':
      size = MEDIUM;
      break;
    case 'small':
      size = SMALL;
      break;
    default:
      size = LARGE;
  }
  const label = translate(content.translations, 'label');
  const secondaryText = translate(content.translations, 'description');
  return (
    <ContentContainer content={content}>
      <BlockHeading title={label} secondaryText={secondaryText} />
      <div className={styles.sliderContainer}>
        <Carousel>
          {content?.components?.map((component, index) => {
            const mediaItem = getMediaItemFromComponent(component);
            if (!mediaItem) return null;
            return (
              <CarouselSlide key={`${mediaItem.url}-${index}`}>
                <div className={styles.imageSlideContainer}>
                  <ImageGalleryAtom
                    url={mediaItem.url}
                    alt={mediaItem?.alt_text || ''}
                    width={size}
                    caption={mediaItem.caption}
                    imageCrop={getImageCropFromComponent(component)}
                    className={styles.imageSlide}
                  />
                </div>
              </CarouselSlide>
            );
          })}
        </Carousel>
      </div>
    </ContentContainer>
  );
}
